import { lazy as layLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    PublicationHistoryCreate: layLoad(async () => {
        const { PublicationHistoryCreate } = await import('./EditPublicationHistory');

        return { default: PublicationHistoryCreate };
    }),
    PublicationHistoryEdit: layLoad(async () => {
        const { PublicationHistoryEdit } = await import('./EditPublicationHistory');

        return { default: PublicationHistoryEdit };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-publication-history.title-add',
        page: lazy.PublicationHistoryCreate,
        path: route.patterns.individualUser.publicationHistory.create,
    },
    {
        documentTitle: 'pages.user-publication-history.title-edit',
        page: lazy.PublicationHistoryEdit,
        path: route.patterns.individualUser.publicationHistory.edit,
    },
];
